import styles from './style.module.css'
import Loading from '../../atoms/Loading'

interface Props {
  children: React.ReactNode,
  title?: string,
  text?: string,
  loading: boolean,
}

export const Form = ({children, title, text, loading}: Props) => {
  return (
    <div className={styles.form_wrapper}>
      <h2 className={styles.h2}>{title}</h2>
      {text && (<div className={styles.text}>{text}</div>)}
      <form className={styles.form}>
        {children}
      </form>
      {loading ? (<>
        <div className="full_screen"><Loading /></div>
        </>):(<>
      </>)}
    </div>
  )
}

export default Form;
